<template>
  <div>
    <div class="bg-white padding" style="position: relative; z-index: 2" ref="card" v-show="favoriteEquipmentList.length>0">
      <div class="input-item flex">
        <div style="display: flex">
          <div class="line"></div>
          <span class="text-nowrap">常用設備號碼</span>
        </div>
        <div>
          <span style="font-size: 16px" class="text-blue" @click="changeModifyListStatus">{{ isListInModify ? '完成' : '編輯' }}</span>
        </div>
      </div>
      <div class="dark-card">
        <div v-for="(item, i) in favoriteEquipmentList" :key="i" class="flex border">
          <div>
            <div>{{ formatTelcomEquipmentNumber1(item.equipment_number) }}</div>
            <div style="font-size: 14px; color: #c7c7c7">{{ hideUserId1(item.identity_number) }}</div>
          </div>
          <div class="delete" v-if="isListInModify" @click="removeFavoriteEquipmentNumber(item.equipment_number_serial_number)"></div>
          <div class="active" v-else @click="getBillIsNull(false, item.equipment_number, item.identity_number)">查詢</div>
        </div>
      </div>
    </div>
    <div class="bg-white padding">
      <div class="input-item flex">
        <div style="display: flex; align-items: center" class="text-nowrap">
          <div class="line"></div>
          {{ favoriteEquipmentList.length>0 ? '查詢其他設備號碼' : '請輸入帳單資訊' }}
        </div>
      </div>
      <div class="form">
        <div>
          <div class="field">            
            <span class="required">*</span>設備號碼
          </div>
          <input type="text" 
            name="equipment_number" 
            placeholder="請輸入設備號碼" 
            class="input vinput" 
            aria-autocomplete="both" aria-haspopup="false" autocapitalize="off" autocorrect="off" autofocus="" role="combobox" spellcheck="false" autocomplete="nope"
            v-model="form.equipmentNumber" 
            @focus="equipmentNumberInFocus = true" 
            @input="changeEquipmentNumber" 
            @blur="equipmentNumberInFocus = false" 
            :class="equipmentNumberError===null ? '' : 'error'"
          />
          <div class="required" v-if="equipmentNumberError!==null">{{ equipmentNumberError }}</div>
          <div class="text-gray2 feild-hint">09 開頭手機、含區碼市話或營運處代號 + 用戶號碼</div>
        </div>
        <div>
          <div class="field">
            <span class="required">*</span>用戶證號
          </div>
          <input 
            type="text" 
            name="identity_number" 
            placeholder="請輸入用戶證號" 
            class="input vinput" 
            v-model="form.identityNumber" 
            @focus="identityNumberInFocus = true" 
            @input="changeIdentityNumber" 
            @blur="identityNumberInFocus = false"
            :class="identityNumberError===null ? '' : 'error'"
             />
          <div class="required" v-if="identityNumberError!==null">{{ identityNumberError }}</div>  
          <div class="text-gray2 feild-hint">身分證字號、護照號、居留證號或企業統編</div>          
        </div>      
        <div class="agree-label" style="margin-bottom: 16pt">
            <input type="checkbox" id="isAddFavroriteChecked" v-model="isAddFavroriteChecked">
            <label for="isAddFavroriteChecked">加入常用設備號碼</label>
        </div>
      </div>
      <button class="btn btn-primary" :disabled="isSearchBtnDisable" ref="search_btn" @click="addFavoriteEquipmentNumber">查詢待繳帳單</button>
    </div>
    <div class="padding description">
      <ul class="text-gray2">    
        <li>每日 07:30-07:35 及 22:10-22:15 為中華電信系統維護時間，請避免於上述時段查詢與繳費。</li>        
        <li>設備號碼為手機號碼、市話號碼 (需加區號) 或營運處代號 + 用戶號碼。</li>      
        <li>用戶證號為登記租用人之身分證字號、居留證號或護照號碼，若為法人請輸入統一編號。</li>
        <li>可使用悠遊付錢包、銀行帳戶連結進行繳費扣款。</li>
        <li>若已設定自動扣繳，請勿重複繳費。</li>
      </ul>
    </div>
    <div :class="isListInModify ? 'mask' : ''" ref="mask"></div>
  </div>
</template>

<script>
import { saveFavoriteEquipmentNumberOfTelcomFee, queryFavoritequipmentNumberOfTelcomFee, deleteFavoritequipmentNumberOfTelcomFee, queryBillList } from '../../api/api';
import { mapActions } from 'vuex';
import { hideUserId } from '../../utils/utils';
import { formatTelcomEquipmentNumber } from '../../utils/format';

export default {
  name: 'cht-telcom-fee',
  data() {
    return {
      favoriteEquipmentList: [],
      isListInModify: false,
      form: {
        equipmentNumber: '',
        identityNumber: '',
      },
      equipmentNumberError: null,
      identityNumberError: null,
      isAddFavroriteChecked: true,     
      equipmentNumberInFocus: false, 
      identityNumberInFocus: false,
    };
  },
  created() {
    this.getFavoriteEquipments();
  },
  computed: {
    isSearchBtnDisable() {
      return this.form.equipmentNumber === '' || this.equipmentNumberError !== null || this.form.identityNumber === '' || this.identityNumberError !== null;
    },    
  },
  watch: {
    isSearchBtnDisable() {
      this.changeEquipmentNumber();
    }
  }, 
  methods: {
    ...mapActions(['setReadyToPayBill']),
    verifyIdentityNumber() {
      const regexp = RegExp(/^[A-Za-z0-9]+$/);
      let result = regexp.test(this.form.identityNumber);
      if (!result) {
        this.identityNumberError = '限輸入英數';
      } else {
        this.identityNumberError = null;
      }
      return result;
    },
    changeIdentityNumber() {
      this.form.identityNumber = this.form.identityNumber.trim().replace(/ /g, '');
      this.verifyIdentityNumber();
    },
    verifyEquipmentNumber() {
      const regexp = RegExp(/^[A-Za-z0-9]{5,}$/);
      let result = regexp.test(this.form.equipmentNumber);
      if (!result) {
        this.equipmentNumberError = '需為 5 碼（含）以上英數字';
      } else {
        this.equipmentNumberError = null;
      }
      return result;
    },
    changeEquipmentNumber() {
      this.form.equipmentNumber = this.form.equipmentNumber.trim().replace(/ /g, '');
      console.log(this.form.equipmentNumber);
      this.verifyEquipmentNumber();
    },
    getFavoriteEquipments() {
      queryFavoritequipmentNumberOfTelcomFee().then((res) => {
        if (res.error === undefined) {
          this.favoriteEquipmentList = res.equipment_number_list;
          setTimeout(() => {
            var height = this.$refs.card.clientHeight;
            this.$refs.mask.style.top = height + 'px';
          }, 1000);
        }
      });
    },
    changeModifyListStatus() {
      this.isListInModify = !this.isListInModify;
    },
    addFavoriteEquipmentNumber() {
      if (this.verifyIdentityNumber() === false) {
        return;
      }
      var form = {
        equipment_number: this.form.equipmentNumber,
        identity_number: this.form.identityNumber,
      };
      if (this.isAddFavroriteChecked) {
        saveFavoriteEquipmentNumberOfTelcomFee(form).then((res) => {
          if (res.error !== undefined) {
            alert(res.error.message);
          } else {
            this.getBillIsNull(false, form.equipment_number, form.identity_number);
          }
        });
      } else {
        this.getBillIsNull(false, form.equipment_number, form.identity_number);
      }
    },
    hideUserId1(userId) {
      return hideUserId(userId);
    },
    formatTelcomEquipmentNumber1(equipmentNumber) {
      return formatTelcomEquipmentNumber(equipmentNumber);
    },
    getBillIsNull(isScanning, equipmentNumber, identityNumber) {
      var form = {
        payment_item_id: 'TWNCH-0109',
        payment_query_type: 'REALTIME-1',
        parameter1: equipmentNumber,
        parameter2: identityNumber,
        parameter3: '',
        payment_custom_id: '',
      };
      queryBillList(form).then((res) => {
        if (res.error === undefined) {
          this.setReadyToPayBill(res);
          this.$router.push({
            path: '/goPay',
            query: form,
          });        
        } else {
          alert(res.error.message);
        }
        if (this.isAddFavroriteChecked) {
          this.getFavoriteEquipments();
        }
      });
    },

    removeFavoriteEquipmentNumber(equipmentSerialNumber) {
      if (confirm('確定要刪除？')) {
        deleteFavoritequipmentNumberOfTelcomFee({ equipment_number_serial_number: equipmentSerialNumber }).then((res) => {
          if (res.error === undefined) {
            this.isListInModify = false;
            this.getFavoriteEquipments();
          } else {
            alert(res.error.message);
          }
        });
      }
    },    
  },
};
</script>

<style scoped>
.required {
  margin-top: 2pt;
  margin-bottom: 26pt;
  font-size: 12pt;
}

.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.border {
  border-bottom: 1px solid rgba(64, 64, 64, 0.75);
  padding: 9pt 0;
}

.field {
  font-size: 14px;
}

.form {
  margin: 24pt 0;
}

.border-bottom {
  margin-bottom: 8pt;
}

.feild-hint {
  font-size: 12pt;
  font-family: PingFangTC-Regular;
  margin-bottom: 24pt;
}
</style>
